import { ParticleNetwork } from '@particle-network/auth';
import { chains } from '@particle-network/chains';
import { iframeWallet } from '@particle-network/iframe-wallet';
import { SolanaWallet } from '@particle-network/solana-wallet';
import { EvmService } from './service/evm-service';
import { SolanaService } from './service/solana-service';
export function ParticleWallet(provider, chainName, options) {
    const pnParams = {
        projectId: options.projectId,
        clientKey: options.clientKey,
        appId: options.appId,
        chainName: options.chainName,
        chainId: Number(options.chainId),
        // authUrl: (process.env.NEXT_PUBLIC_AUTH_URL || 'https://auth.particle.network') as string,
        wallet: {
            displayWalletEntry: false,
        },
    };
    try {
        if (chainName.toLowerCase() === 'solana') {
            // @ts-ignore
            let pn = window.particle;
            try {
                // @ts-ignore
                if (window.__connectId !== 'particle' && window.isNewParticle) {
                    // @ts-ignore
                    pn = window.particle;
                    // @ts-ignore
                }
                else if (window.__connectId !== 'particle') {
                    pn = new ParticleNetwork(pnParams);
                }
            }
            catch (error) {
                console.log('new ParticleNetwork error', error);
            }
            const { inAuthCoreIframe, chainId, chainName } = window.__webWalletData || {};
            let _provider = null;
            if (inAuthCoreIframe) {
                _provider = iframeWallet.solana;
            }
            else if (iframeWallet) {
                const currentChainInfo = chains.getChainInfo({
                    id: chainId,
                    name: chainName,
                });
                pn?.auth.setChainInfo(currentChainInfo);
                _provider = new SolanaWallet(pn?.auth);
            }
            else {
                _provider = new SolanaWallet(pn?.auth);
            }
            options.mockAddress = options.mockSolanaAddress;
            return new SolanaService(provider, _provider, options);
        }
        else {
            options.mockAddress = options.mockEvmAddress;
            return new EvmService(provider, options);
        }
    }
    catch (error) {
        console.log('ParticleWallet error', error);
        return {};
    }
}
//# sourceMappingURL=particle-wallet.js.map